module.exports = "/assets/data/58efcc8f589df8a901b7d90587b8d761-KT22.data.json";